import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import { Scrollbars } from 'react-custom-scrollbars';
import IconWithLabel from '../IconWithLabel/IconWithLabel';

export default class Sidebar extends React.Component {
    static propTypes = {
        isExpanded: PropTypes.bool,
        toggleExpanded: PropTypes.func
    }

    state = {
        activeItems: [],
        menuItems: [
            {
                "name": "Content Ingestion",
                "icon": "note-24",
                "items": [
                    {
                        "name": "Upload Content",
                        "link": "/content-upload"
                    },
                    {
                        "name": "Upload Metadata",
                        "link": "/metadata-upload"
                    },
                    {
                        "name": "View Logs",
                        "link": "/view-logs"
                    }
                ]
            },
            {
                "name": "Content Management",
                "icon": "edit-24",
                "items": [
                    {
                        "name": "Content Management",
                        "link": "/content-management"
                    },
                    {
                        "name": "Content Update Status",
                        "link": "/content-update-status"
                    },
                    {
                        "name": "Metadata Update Status",
                        "link": "/metadata-update-status"
                    },
                    {
                        "name": "Pricing Update Status",
                        "link": "/price-update-status"
                    },
                    {
                        "name": "Collections Pricing",
                        "link": "/pricing-calculation"
                    }
                ]
            },
            {
                "name": "CC Management",
                "icon": "book-24",
                "items": [
                    {
                        "name": "Import Curated Collection",
                        "link": "/cc-management-upload"
                    },
                    {
                        "name": "Delete Curated Collection",
                        "link": "/cc-management-delete"
                    },
                    {
                        "name": "Curated Content Management",
                        "link": "/curated-content-management"
                    },
                    {
                        "name": "CC Creation Status",
                        "link": "/cc-management-status"
                    },
                    {
                        "name": "CC Migration Status",
                        "link": "/cc-migration-status"
                    },
                    {
                        "name": "CC Deletion Status",
                        "link": "/cc-deletion-status"
                    }
                ]
            }
        ]
    }

    toggleHeader = (name) => {
        if (!this.props.isExpanded) {
            this.toggleSidebar();

            this.setState({
                activeItems: [name]
            });
        } else {
            this.setState(prevState => ({
                activeItems: (prevState.activeItems.includes(name) 
                    ? prevState.activeItems.filter((i) => i !== name) 
                    : [...prevState.activeItems, name])
            }));
        }        
    }

    toggleSidebar = () => {
        this.setState({
            activeItems: (this.props.isExpanded) ? [] : this.state.menuItems.map((_, i) => i)
        });

        this.props.toggleExpanded();
    }

    render () {
        const { isExpanded } = this.props;
        return (
            <div className="sidebar">
                <Scrollbars autoHide autoHeight autoHeightMin={0} autoHeightMax={"100%"}>
                    <div className="menu">
                        {
                            this.state.menuItems.map((section, key) => (
                                <React.Fragment>
                                    <div className="menu-header" onClick={() => this.toggleHeader(key)}><IconWithLabel icon={section.icon} label={section.name} /></div>
                                    <ul className={(this.state.activeItems.includes(key) ? "" : "hidden")}>
                                        {
                                            section.items.map((name, key) => <li key={key}><Link to={name.link}>{name.name}</Link></li>)
                                        }
                                    </ul>
                                </React.Fragment>
                            ))
                        }
                    </div>
                </Scrollbars>

                <div className="toggle-switch" onClick={this.toggleSidebar}>
                    <Icon name={`chevron-${(isExpanded ? "back" : "next")}-24`}/>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgets/SideNavBar/Sidebar.js